import { Form } from "antd";
import Inputs from "../Inputs/Inputs";
import { useState } from "react";
import SwitchToggle from "../switch/SwitchToggle";
import Selects from "../Selects/Selects";
import { useSelector } from "react-redux";
import { RootState } from "../../apis/store";
import { useTranslation } from "react-i18next";
import { FaEye } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../Modal/ModalComponent";

interface GiftProps {
  variant?: "donation" | "payment";
  form: any;
  requirePhoneNumber?: boolean;
  isDonationGiftEnabled: boolean;
  setIsDonationGiftEnabled: (v: boolean) => void;
}
const Gift = ({
  variant,
  form,
  requirePhoneNumber = false,
  isDonationGiftEnabled,
  setIsDonationGiftEnabled,
}: GiftProps) => {
  const cardTypes = useSelector(
    (state: RootState) => state?.donation?.cardTypes
  );

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [card, setCard] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  //for name
  const [isNameGiftEnabled, setIsNameGiftEnabled] = useState<boolean>(false);
  const [isAmountGiftEnabled, setIsAmountGiftEnabled] =
    useState<boolean>(false);

  //for copy mobile
  const [isPhoneEnabled, setIsPhoneEnabled] = useState(false);

  const handleDonationGiftChange = async () => {
    if (isDonationGiftEnabled) {
      form.setFields([
        {
          name: "inputFieldPhoneNumber",
          errors: [],
        },
      ]);
    }
    setIsDonationGiftEnabled(!isDonationGiftEnabled);
    setIsPhoneEnabled(false);
    setIsNameGiftEnabled(false);
  };

  //remove input Phone error when switch is disabled
  const handleSwitchChange = (value: boolean) => {
    setIsPhoneEnabled((prevState) => {
      const newState = !prevState;
      if (newState) {
        form.validateFields(["inputFieldPhoneNumber"]).catch(() => {});
      } else {
        form.resetFields(["inputFieldPhoneNumber"]);
      }
      return newState;
    });

    form.setFieldValue("sendCopie", value);
  };

  return (
    <>
      <Form
        form={form}
        name="customInputForm"
        initialValues={{ remember: true }}
        className="takaful--donation-form takaful--donation-form-gift"
      >
        <Form.Item
          className="takaful--donation-input-validation takaful-error-message takaful--donation-form-gift-mobile"
          name="inputFieldDonnerName"
          rules={[
            {
              validator: (_, value) => {
                if (value && !/^[A-Za-z\u0600-\u06FF\s]+$/.test(value)) {
                  return Promise.reject(
                    new Error("فقط الحروف مسموح بها!")
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Inputs
            sizeInput="middle"
            className="takaful--donation-input takaful--inputs-donation-home-details"
            type="text"
            placeholder="اسم المتبرع"
          />
        </Form.Item>
        <Form.Item
          className="takaful--donation-input-validation takaful-error-message takaful--donation-form-gift-mobile"
          name="inputFieldPhoneNumber"
          rules={[
            {
              required:
                requirePhoneNumber || (variant !== "donation" && isPhoneEnabled),
              message: "رقم الجوال مطلوب",
            },
            {
              validator: (_, value) => {
                if (value && !/^[0-9]+$/.test(value)) {
                  return Promise.reject(
                    new Error("فقط الأرقام الموجبة مسموح بها!")
                  );
                }
                if (value && value.toString().length !== 10) {
                  return Promise.reject(
                    new Error("يجب أن يتكون رقم الهاتف من 10 ارقام")
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Inputs
            sizeInput="middle"
            className="takaful--donation-input takaful--inputs-donation-home-details"
            type="tel"
            placeholder="05XXXXXXXX"
            maxLength={10}
          />
        </Form.Item>

        {variant === "payment" && (
          <div className="takaful--details-project-card-donation">
            <SwitchToggle
              switchState={isDonationGiftEnabled}
              onSwitchChange={handleDonationGiftChange}
              label="ارسال التبرع عبر الاهداء"
            />
            {isDonationGiftEnabled && (
              <>
                <Form.Item
                  name="card_id"
                  label=""
                  className="takaful--donation-selects"
                  rules={[
                    {
                      required: true,
                      message: "نوع البطاقة مطلوب",
                    },
                  ]}
                >
                  <Selects
                    className="takaful--inputs-donation-home-details"
                    onChange={(e) => setSelectedCard(e)}
                    options={cardTypes.map((type: any) => ({
                      id: type.id,
                      name: type.name,
                    }))}
                    selectPlaceholder="نوع البطاقة"
                    allowClear={true}
                  />
                </Form.Item>
                <div
                  className="takaful--details-project-card-donation-box"
                  style={{ gap: "1rem" }}
                >
                  <FaEye
                    className="takaful--donation-eye"
                    onClick={() =>
                      setCard(form.getFieldValue("card_id") ?? false)
                    }
                    style={{ color: selectedCard ? "#1f3d60" : "" }}
                  />
                  <p className="takaful--donation-card-text">مشاهدة البطاقة</p>
                </div>
                <Form.Item
                  name="showName"
                  label=""
                  className="takaful--donation-selects "
                  style={{ marginBottom: "0px" }}
                >
                  <SwitchToggle
                    label="إظهار اسمك في الاهداء"
                    switchState={isNameGiftEnabled}
                    onSwitchChange={() => {
                      form.setFieldValue("showName", !isNameGiftEnabled);
                      setIsNameGiftEnabled(!isNameGiftEnabled);
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="show_amount"
                  label=""
                  className="takaful--donation-selects "
                >
                  <SwitchToggle
                    label="إظهار المبلغ للمهدى إليه"
                    switchState={isAmountGiftEnabled}
                    onSwitchChange={() => {
                      form.setFieldValue("show_amount", !isAmountGiftEnabled);
                      setIsAmountGiftEnabled(!isAmountGiftEnabled);
                    }}
                  />
                </Form.Item>
                <div className="takaful--donation-form">
                  {isNameGiftEnabled && (
                    <Form.Item
                      className="takaful-error-message"
                      name="inputFieldName"
                      rules={[
                        {
                          required: true,
                          message: "الإسم مطلوب",
                        },
                        {
                          validator: (_, value) => {
                            if (
                              value &&
                              !/^[A-Za-z\u0600-\u06FF\s]+$/.test(value)
                            ) {
                              return Promise.reject(
                                new Error("فقط الحروف مسموح بها!")
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Inputs
                        placeholder="اسمك"
                        type="text"
                        className="takaful--inputs-donation-home-details"
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    className="takaful-error-message"
                    name="inputFieldDedicatedName"
                    rules={[
                      {
                        required: true,
                        message: " إسم المهدى له مطلوب",
                      },

                      {
                        validator: (_, value) => {
                          if (
                            value &&
                            !/^[A-Za-z\u0600-\u06FF\s]+$/.test(value)
                          ) {
                            return Promise.reject(
                              new Error("فقط الحروف مسموح بها!")
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <div className="takaful--donation-input-container">
                      <Inputs
                        sizeInput="middle"
                        className="takaful--donation-input takaful--inputs-donation-home-details "
                        type="text"
                        placeholder="المهدى له "
                      />
                    </div>
                  </Form.Item>
                  <Form.Item
                    className="takaful--donation-input-validation takaful-error-message"
                    name="inputFieldPhone"
                    rules={[
                      {
                        required: true,
                        message: " رقم الجوال مطلوب",
                      },
                      {
                        validator: (_, value) => {
                          if (value && !/^[0-9]+$/.test(value)) {
                            return Promise.reject(
                              new Error("فقط الأرقام الموجبة مسموح بها!")
                            );
                          }
                          if (value && value.toString().length !== 10) {
                            return Promise.reject(
                              new Error("يجب أن يتكون رقم الهاتف من 10 ارقام")
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Inputs
                      sizeInput="middle"
                      className="takaful--donation-input takaful--inputs-donation-home-details"
                      type="tel"
                      maxLength={10}
                      placeholder="05XXXXXXXX"
                    />
                  </Form.Item>
                  <Form.Item
                    className="takaful--donation-input-validation takaful-error-message"
                    name="sendCopie"
                  >
                    <SwitchToggle
                      label="إرسال نسخة إلى جوالي"
                      switchState={isPhoneEnabled}
                      onSwitchChange={handleSwitchChange}
                    />
                  </Form.Item>
                </div>
              </>
            )}
          </div>
        )}
      </Form>
      {variant === "donation" ? (
        <>
          <p
            style={{ marginTop: "-0.7rem" }}
            className="takaful--donation-card-text"
          >
            {t("donation.text")}
          </p>
          <p
            style={{ marginTop: "-0.7rem" }}
            className="takaful--donation-card-text"
          >
            {" "}
            بإمكانك{" "}
            <span
              onClick={() => navigate("/login")}
              style={{ cursor: "pointer" }}
            >
              تسجيل الدخول
            </span>
          </p>
        </>
      ) : (
        <p
          style={{ textAlign: "right" }}
          className="takaful--donation-card-text"
        >
          بإتمام التبرع أنت توافق على&nbsp;
          <span style={{ color: "#02AB0A", cursor: "pointer" }}>
            سياسة المساهمة
          </span>
        </p>
      )}

      <ModalComponent
        open={card}
        title=""
        onClose={() => setCard(false)}
        closeOnOutsideClick
      >
        <div style={{ justifyContent: "center", display: "flex" }}>
          <img alt=""
            src={
              form.getFieldValue("card_id")
                ? cardTypes.filter(
                    (el: any) => el.id === form.getFieldValue("card_id")?.key
                  )[0].image_cover_ids[0]
                : null
            }
          />
        </div>
      </ModalComponent>
    </>
  );
};

export default Gift;
